(ns motorsaif.web.pages.sign-up
  (:require
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.web.components :as c]
   [motorsaif.web.components.step-inputs :as si]
   [motorsaif.web.components.user-handle :as c-handle]
   [motorsaif.web.lib.form :as form]
   [motorsaif.log :as log]
   [motorsaif.web.svg :as svg]
   [motorsaif.validation :as validation]
   [re-frame.core :as rf :refer [dispatch]]
   [reagent.core :as r]
   [taoensso.encore :as encore]))


;; Start
(defn root []
  (let [trs (i18n/tr-scope [:page :sign-up])]
    [:div#register-root.container-sm
     [:h1 (trs :title "Registration")]

     (let [trs (i18n/tr-scope [:page :sign-up :business])]
       [:section.business
        [:a.option
         {:href (routes/path-for :business-sign-up)}
         [:div.title (trs :title "Business Account")]
         [:div.grid
          [:p (trs :desc "Gain more customers by responding to their requests")]
          [:img {:src "/static/img/signup/bizsignup.webp"}]
          [:span.cta.mono (trs :cta "Register Business")]]]])

     (let [trs (i18n/tr-scope [:page :sign-up :personal])]
       [:section.personal
        [:a.option
         {:href (routes/path-for :personal-sign-up)}
         [:div.title (trs :title "Personal Account")]
         [:div.grid
          [:img {:src "/static/img/signup/privsignup.webp"}]
          [:p (trs :desc "Make requests for repairs, parts, or upgrades for your vehicles")]
          [:span.cta.mono (trs :cta "Create Account")]]]])

     [:p.login.tac
      [:a.btn.outline.shadow {:href (routes/path-for :login)}
       [:span (tr :forms.sign-up.existing-account.have)]
       [:span.bold.text.clr-brand-secondary
        (tr :forms.sign-up.existing-account.sign-in)]]]]))
